import React, { useEffect, useState } from 'react'
import _get from 'lodash/get'
import _map from 'lodash/map'
import _filter from 'lodash/filter'
import Field from '../../../_library/Field'
import { SectionBlock } from './EventDetailsLeftSection'
import { isEmailValidator } from '../../../../_common/core/validation'
import { getConfig } from '../../../utils/configUtils'
import { getPromoters } from '../../../../_common/core/http_services'
import { showAxiosError } from '../../../utils/messenger'
import SortableTable from '../../../_library/SortableTable'
import { getTableColumns } from '../../../utils/sortableTableUtils'
import { ENV } from '../../../constants/env'

const getPaymentPlanStrValue = event => {
  const length = event?.stripePaymentPlanLength
  const interval = event?.stripePaymentPlanInterval

  const count = Number(length) / Number(interval)
  const intervalStr = Number(interval) === 7 ? 'Weekly' : 'Monthly'
  let instalmentStr = 'instalment'

  if (count > 1) {
    instalmentStr += 's'
  }

  if (!count) {
    return null
  }

  return `${count} ${intervalStr} ${instalmentStr}`
}

const BrandDetails = ({
  event,
  brand,
  flagSendPromoterLinks,
  setFlagSendPromoterLinks,
  onInputChange,
  values,
}) => {
  const configs = getConfig()
  const isSupportEmailFieldsVisible = _get(
    configs,
    'global.children.EventPublish.appearance.isSupportEmailFieldsVisible',
  )
  const isPayoutsInfoVisible = _get(configs, 'global.children.EventPublish.appearance.isPayoutsInfoVisible')

  const [promoters, setPromoters] = useState(null)
  const [showMore, setShowMore] = useState(false)

  const fetchPromotersData = async eventId => {
    try {
      const response = await getPromoters(eventId)
      setPromoters(
        _map(
          _filter(response.data, promoter => !promoter.email.includes('@theticketfairy.com')),
          item => ({
            ...item,
            fullName: `${item.firstName} ${item.lastName}`,
            url: `${ENV.API_CONSUMER}/r/${eventId}/${item.promoterId}`,
          }),
        ),
      )
    } catch (error) {
      showAxiosError(error)
    }
  }

  useEffect(() => {
    fetchPromotersData(event.id)
  }, [event.id])

  const paymentDetails = [
    { id: 'paymentMethod', label: 'Payment method', value: event?.paymentMethod?.name },
    { id: 'accountNumber', label: 'Account Number/ACH', value: event.bankingDetails.accountNumber },
    { id: 'accountName', label: 'Account Name', value: event.bankingDetails.accountName },
    { id: 'sortCode', label: 'Sort-Code', value: event.bankingDetails.sortCode },
    { id: 'paymentPlan', label: 'Payment Plan', value: getPaymentPlanStrValue(event) },
  ]

  const brandSupportFields = [
    isSupportEmailFieldsVisible && {
      key: 'externalSupportEmail',
      label: 'Contact Email for Escalations',
      helperText: 'External use to provide to customers',
      disabled: false,
      value: values.externalSupportEmail,
    },
    isSupportEmailFieldsVisible && {
      key: 'internalSupportEmail',
      label: 'Point of Contact Email for TF Support',
      helperText: 'Internal Use Only',
      disabled: false,
      value: values.internalSupportEmail,
    },
  ].filter(Boolean)

  return (
    <div className="brand-details-container">
      <div className="left-section col-xs-4">
        <SectionBlock
          label="Payment Details"
          subLabel="This cannot be changed once published"
          subLabelIcon="/resources/images/information-warning.svg"
          infoBlocks={paymentDetails}
          isLastItem={true}
          icon="/resources/images/system_icons/ticket-buyer.svg"
        />
        {event?.flagIsStripePaymentMethod && isPayoutsInfoVisible && (
          <div style={{ marginTop: 40 }}>
            <h5>
              <span>{event.flagIsStripeConnected ? 'Advance payouts' : 'Post-event payouts'}</span>
              <img
                alt="nodata"
                src={asset('/resources/images/check-mark-round.svg')}
                style={{ width: 12, height: 12, paddingBottom: 0, marginLeft: 5 }}
              />
            </h5>
            <h5>
              {!event.flagIsStripeConnected ? (
                <div
                  className="alert"
                  style={{
                    backgroundColor: '#31708f47',
                    border: '1px solid rgba(217, 161, 79, 0.7);',
                    fontSize: '12px',
                    lineHeight: '16px',
                  }}
                >
                  <span>
                    This event has not been connected to your own Stripe account. Therefore, payouts will be
                    processed 10-15 days after the event concludes, in accordance with our Payouts Policy.
                  </span>
                  {!showMore && (
                    <span
                      aria-hidden
                      onClick={() => setShowMore(true)}
                      style={{ margin: '0 5px', fontWeight: 600, cursor: 'pointer' }}
                    >
                      View more
                    </span>
                  )}
                  {showMore && (
                    <span>
                      {' '}
                      Please note that post-event payouts may be delayed due to various factors, with the most
                      common ones being:
                      <ul style={{ marginLeft: '-15px' }}>
                        <li> The event is classified as high-risk (delay up to 120 days)</li>
                        <li>There are pending refund requests for the event (delay up to 90 days)</li>
                        <li>
                          There are multiple customer chargebacks or complaints related to the event (delay up
                          to 120 days)
                        </li>
                        <li>
                          The event has been postponed (payouts will be released after the event takes place).
                        </li>
                        <li>
                          The event has been cancelled (payouts will be withheld, and we will process all
                          refunds on your behalf).
                        </li>
                      </ul>
                    </span>
                  )}
                  {showMore && (
                    <div
                      aria-hidden
                      onClick={() => setShowMore(false)}
                      style={{ margin: '0', fontWeight: 600, cursor: 'pointer' }}
                    >
                      Hide
                    </div>
                  )}
                  <div>
                    <br />
                    <strong>
                      If you’d like to enable advance payouts, please click &nbsp;
                      <span
                        aria-hidden
                        style={{ cursor: 'pointer', fontWeight: 800, textDecoration: 'underline' }}
                        onClick={() => {
                          window.location.href = `/brand/${event.owner.id}/details`
                        }}
                      >
                        here
                      </span>
                      , and select the ‘Connect Stripe Account’ button under the ‘Payment Method’ section.
                    </strong>
                  </div>
                </div>
              ) : (
                <div
                  className="alert alert-success"
                  style={{
                    fontSize: '12px',
                    lineHeight: '16px',
                    backgroundColor: '#29f2c594',
                    color: 'white',
                  }}
                >
                  <span>
                    This event has been connected to your Stripe account via Stripe Connect. If you’d like to
                    change the payment method or Stripe account, you can do so by clicking{' '}
                    <span
                      aria-hidden
                      style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 700 }}
                      onClick={() => {
                        window.location.href = `/brand/${event.owner.id}/details`
                      }}
                    >
                      here
                    </span>{' '}
                    and selecting ‘Connect Stripe Account’, or by emailing support at
                    support@theticketfairy.com.
                  </span>
                </div>
              )}
            </h5>
          </div>
        )}
      </div>
      <div className="right-section col-xs-8">
        {isSupportEmailFieldsVisible && (
          <h4>
            <img
              alt="nodata"
              src={asset('/resources/images/system_icons/support.svg')}
              style={{ width: 14, paddingBottom: 3, marginRight: 5 }}
            />
            Brand Support Contact Needed
          </h4>
        )}
        {brandSupportFields.map(field => (
          <div className="row" key={field.key}>
            <div className="col-xs-12">
              <div style={{ display: 'block', margin: '10px 0 -14px' }}>{field.label}</div>
              <Field
                name={field.key}
                value={
                  field.key === 'externalSupportEmail' || field.key === 'internalSupportEmail'
                    ? field.value
                    : _get(event, field.key) || _get(brand, field.key) || ''
                }
                error={
                  field.key === 'externalSupportEmail' || field.key === 'internalSupportEmail'
                    ? field.value
                      ? isEmailValidator()(field.value)
                      : 'Required'
                    : ''
                }
                touched={!(field.value || '') || isEmailValidator()(field.value)}
                disabled={field.disabled}
                helperText={field.helperText}
                onChange={e => {
                  const fieldValue = e.target.value
                  onInputChange(field.key, fieldValue)
                }}
              />
            </div>
          </div>
        ))}
        {promoters && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', verticalAlign: 'center' }}>
              <h4>
                <a href={`/event/${event.id}/performance/sales-by-promoter`}>Promoters</a>
              </h4>
              <div
                className="checkbox-group-square"
                style={{ display: 'flex', gap: '5px', verticalAlign: 'center' }}
              >
                <div className="checkbox-square" style={{ width: 24, height: 24 }}>
                  <input
                    id="flagSendPromoterLinks"
                    type="checkbox"
                    checked={flagSendPromoterLinks}
                    value={flagSendPromoterLinks}
                    onChange={e => {
                      setFlagSendPromoterLinks(e.target.checked)
                    }}
                  />
                  <label htmlFor="flagSendPromoterLinks" style={{ width: 24, height: 24, margin: 0 }} />
                </div>
                <label
                  htmlFor="flagSendPromoterLinks"
                  className="checkbox-description"
                  style={{ display: 'flex', alignItems: 'center', marginTop: 0 }}
                >
                  Send Promoter Links
                </label>
              </div>
            </div>

            <SortableTable
              data={promoters}
              tableColumns={getTableColumns([
                { key: 'fullName', label: 'Promoter Name' },
                { key: 'url', label: 'Promoter Link' },
              ])}
              enableSort={true}
              enableCopyTable={false}
              disableMobileView={true}
              parentTableClass="scrollable"
            />
          </>
        )}
      </div>
    </div>
  )
}

export default BrandDetails
